// simple wrapper to enforce that you pass the right type
export function setLoading(type) {
    let matches = /(.*)_(REQUEST|SUCCESS|FAILURE)/.exec(type);
    if(matches) {
        return {type};
    }

    return null;
}
